import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function LogoutConfirmation({ show, onHide, onLogout }) {
  const [keepLoggedInForToday, setKeepLoggedInForToday] = useState(false);

  const handleLogout = () => {
    onLogout(keepLoggedInForToday);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Confirm Logout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to log out? Any unsaved changes may be lost.</p>
        <Form.Check 
          type="checkbox"
          id="keep-logged-in-checkbox"
          label="Keep me logged in for today (until midnight)"
          checked={keepLoggedInForToday}
          onChange={(e) => setKeepLoggedInForToday(e.target.checked)}
          className="mt-3"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          variant={keepLoggedInForToday ? "success" : "danger"} 
          onClick={handleLogout}
        >
          {keepLoggedInForToday ? "Continue Session" : "Logout"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LogoutConfirmation; 